// Documentation: https://next.vuex.vuejs.org/
import { createStore } from 'vuex'

// Automatically import all .json, .yaml, .yml, and .md files from @/data and subdirectories
const dataContext = require.context('@/data', true, /\.(json|ya?ml|md)$/);

function loadAllData() {
  const data = {
    content: {}
  };

  dataContext.keys().forEach(key => {
    const rawModule = dataContext(key);
    const fileData = rawModule && rawModule.default !== undefined ? rawModule.default : rawModule;

    // Strip leading "./" and file extension
    const cleanPath = key.replace(/^\.\//, '').replace(/\.(json|ya?ml|md)$/, '');
    const parts = cleanPath.split('/');

    if (parts.length === 1) {
      const prop = parts[0];
      const camelProp = prop.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
      data[prop] = fileData;
      if (camelProp !== prop) {
        data[camelProp] = fileData;
      }
    } else {
      let current = data;
      for (let i = 0; i < parts.length - 1; i++) {
        const folder = parts[i];
        current[folder] = current[folder] || {};
        current = current[folder];
      }
      const fileName = parts[parts.length - 1];
      const camelFileName = fileName.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
      current[fileName] = fileData;
      if (camelFileName !== fileName) {
        current[camelFileName] = fileData;
      }
    }
  });

  return data;
}

export default createStore({
  state: loadAllData(),
  mutations: {
    setAllData(state, data) {
      Object.assign(state, data);
    }
  },
  actions: {
    loadData({ commit }) {
      commit('setAllData', loadAllData());
    }
  },
  modules: {}
})
